import { Link } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "../Footer";
import "../pages/PolicyPages.css";

function LegalLayout({
  title,
  description,
  lastUpdated,
  sections = [],
  children,
}) {
  return (
    <div className="legal-page">
      <Navbar />

      <main className="legal-main">
        <div className="legal-wrapper">

          <nav className="legal-breadcrumb" aria-label="Breadcrumb">
            <Link to="/">Home</Link>
            <span>/</span>
            <span>Legal</span>
            <span>/</span>
            <span>{title}</span>
          </nav>

          <section className="legal-hero">
            <div className="legal-hero-content">
              <span className="legal-eyebrow">CODEION LEGAL</span>

              <h1>{title}</h1>

              {description && (
                <p className="legal-description">{description}</p>
              )}

              {lastUpdated && (
                <div className="legal-updated">
                  <span className="legal-updated-dot"></span>
                  Last updated: {lastUpdated}
                </div>
              )}
            </div>
          </section>

          <div className="legal-layout">

            {sections.length > 0 && (
              <aside className="legal-sidebar">
                <div className="legal-sidebar-card">
                  <p className="legal-sidebar-title">ON THIS PAGE</p>

                  <nav className="legal-toc">
                    {sections.map((section) => (
                      <a key={section.id} href={`#${section.id}`}>
                        <span>{section.number}</span>
                        {section.label}
                      </a>
                    ))}
                  </nav>

                  <div className="legal-sidebar-help">
                    <p>Need help?</p>

                    <span>
                      Contact our support team if you have questions about
                      these terms.
                    </span>

                    <a href="mailto:support@codeion.in">
                      Contact Support →
                    </a>
                  </div>
                </div>
              </aside>
            )}

            <article className="legal-content">
              {children}
            </article>

          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}

export default LegalLayout;